import { useCallback } from 'react';
import usePersonalInfoService from './personalInfo';
import useStores from '../../hooks/useStores';
import useEpisodeofCareService from './episodeofCareInfo';
import { startCase } from 'lodash';

export const usePatientProfileService = () => {
  const { patientProfileStore } = useStores();
  const personalInfo = usePersonalInfoService();
  const episodeOfCareInfo = useEpisodeofCareService();

  const handleUpdateStatus = useCallback(
    async (updateFn: () => void, name?: string, action?: string) => {
      try {
        // TODO: Remove this commit when confirm this not used.
        // patientProfileStore.setUpdatingStatus(updatingStatusEnum.inProgress);
        await updateFn();

        // patientProfileStore.setUpdatingStatus(updatingStatusEnum.done);
        // setTimeout(
        //   () =>
        //     patientProfileStore.setUpdatingStatus(updatingStatusEnum.initial),
        //   2000
        // );
      } catch {
         console.error(`Failed to ${action || 'save'} ${startCase(name)}`)
        // patientProfileStore.setUpdatingStatus(
        //   updatingStatusEnum.failed,
        //   name,
        //   action
        // );
      }
    },
    []
  );

  return {
    personalInfo,
    episodeOfCareInfo: episodeOfCareInfo,
    isLoading: personalInfo.isLoading,
    state: patientProfileStore,
    handleUpdateStatus,
  };
};
